import { Capacitor, registerPlugin } from "@capacitor/core";

// iOS only: mirror the Yalola UI language into the app's iOS language (AppleLanguages)
// so the system UI inside the app (Paste/AutoFill menu, permission alerts, share sheet)
// matches at the next cold launch. No-op on web / Android (their system UI already
// follows the device). Resolves true when iOS will switch at next launch.
let plugin = null;
export async function syncNativeAppLanguage(lang) {
  try {
    if (Capacitor.getPlatform() !== "ios" || !Capacitor.isPluginAvailable("AppLanguage")) return false;
    plugin = plugin || registerPlugin("AppLanguage");
    const r = await plugin.set({ lang });
    return !!r?.changed;
  } catch {
    return false;
  }
}
